const _import = require('./_import_production'); // 获取组件的方
export default [
    {
        path: '/register',
        name: 'register',
        component: _import('register/register')
    },
    {
        // 平台使用协议
        path: '/agreement',
        name: 'agreement',
        component: _import('register/agreement')
    },
    {
        path: '/setPw',
        name: 'setPw',
        component: _import('register/setPw')
    },
    {
        path: '/role',
        name: 'role',
        component: _import('register/role')
    },
    {
        path: '/success',
        name: 'success',
        component: _import('register/success')
    },
    {
        path: '/login',
        name: 'login',
        component: _import('login/login')
    },
    {
        path: '/phone',
        name: 'phone',
        component: _import('resetPasswd/phone')
    },
    {
        path: '/resetPw',
        name: 'resetPw',
        component: _import('resetPasswd/resetPw')
    },
    {
        path: '/resetSuccess',
        name: 'resetSuccess',
        component: _import('resetPasswd/resetSuccess')
    },
    {
        path: '/selectRole',
        name: 'selectRole',
        component: _import('login/selectRole')
    },
    {
        path: '/helpBuy', // 帮助中心-竞买人
        name: 'helpBuy',
        component: _import('helpCen/helpBuy')
    },
    {
        path: '/helpNeer', // 帮助中心-拍卖师
        name: 'helpNeer',
        component: _import('helpCen/helpNeer')
    },
    {
        path: '/helpCompany', // 帮助中心-拍卖公司
        name: 'helpCompany',
        component: _import('helpCen/helpCompany')
    },
    {
        path: '/SimulationBidding', // 帮助中心-模拟竞拍-竞买人
        name: 'SimulationBidding',
        component: _import('helpCen/SimulationBidding')
    },
    {
        path: '/MobilePhoneBidder', // 手机APP竞买人操作说明
        name: 'MobilePhoneBidder',
        component: _import('helpCen/MobilePhoneBidder')
    },
    {
        path: '/', // 首页
        // name: 'Index',
        redirect: '/home',
        component: () => import('@/components/Index'),
        children: [{
            path: 'home', // 首页
            name: 'home',
            component: _import('Home/Home')
        },

        {
            path: '/banInvest', // banner连接
            name: 'banInvest',
            component: _import('bannerPage/investment')
        },
        {
            path: '/ChinaMerchants', // banner连接
            name: 'ChinaMerchants',
            component: _import('bannerPage/ChinaMerchants')
        },
        {
            path: '/banAuct', // banner连接
            name: 'banAuct',
            component: _import('bannerPage/auction')
        },
        {
            path: '/search', // 查询
            name: 'search',
            component: _import('search/search')
        },
        {
            path: '/nothing', // 查询
            name: 'nothing',
            component: _import('search/nothing')
        },
        {
            path: '/childweb', // 子站更多
            name: 'childweb',
            component: _import('coopChildWeb/childWeb')
        },
        {
            path: '/auctComp', // 驻场拍卖公司
            name: 'home',
            component: _import('auctComp/auctComp')
        },
        {
            path: '/auctCompDetail', // 驻场拍卖公司
            name: 'auctCompDetail',
            component: _import('auctComp/auctCompDetail')
        },
        {
            path: '/auctCompDetail2', // 驻场委托人
            // name: 'auctCompDetail2',
            component: _import('auctComp/auctCompDetail2')
        },
        {
            path: '/producDetail', // 招商详情
            name: 'attractsy',
            component: () => import('@/components/aution/ProducDetails')
        },
        {
            path: '/tradeDetail', // 标的详情
            name: 'tradeDetail',
            component: () => import('@/components/aution/tradeDetails')
        },

        {
            path: '/tradeDetail1', // 支付详情
            name: 'tradeDetail1',
            component: () => import('@/components/aution/tradeDetails1')
        },

        {
            path: '/noticeDetail', // 公告详情
            name: 'notice',
            component: () => import('@/components/aution/noticeDetails')
        },
        {
            path: '/details', // 产品详情
            name: 'details',
            component: () => import('@/components/goodsDetail/GoodsShow')
        },
        {
            path: '/attractsy', // 招商推荐
            name: 'attractsy',
            component: _import('Attractsy/Attractsy')
        },
        {
            path: '/banking', // 金融资产
            name: 'banking',
            component: _import('Banking/Banking')
        },
        {
            path: '/trade', // 项目交易
            name: 'trade',
            component: _import('trade/trade')
        },
        {
            path: '/notice', // 项目公告
            name: 'notice',
            component: _import('notice/notices')
        },
        {
            path: '/service', // 服务专区
            name: 'service',
            component: _import('service/services')
        },
        {
            path: '/moreAuc', // 更多拍卖会
            name: 'moreAuc',
            component: _import('bannerPage/moreAuction')
        },
        {
            path: '/moreSpecialPerformance', // 更多招商专场会
            name: 'moreSpecialPerformance',
            component: _import('bannerPage/moreSpecialPerformance')
        },
        {
            path: '/IndusNews', // 行业动态
            name: 'IndusNews',
            redirect: '/IndusNews/dpai',
            component: _import('indusNews/index'),
            children: [{
                path: 'dpai', // 点拍动态
                name: 'dpai',
                component: _import('indusNews/dpai/list')
            },
            {
                path: 'dpaiDetail', // 点拍动态
                name: 'dpai',
                component: _import('indusNews/dpai/details')
            },
            {
                path: 'laws', // 政策法规
                name: 'laws',
                component: _import('indusNews/laws/list')
            },
            {
                path: 'lawsDetail', // 政策法规
                name: 'laws',
                component: _import('indusNews/laws/details')
            }
            ]
        },
        {
            path: '/myAuction',
            name: 'myAuction',
            component: { // 这时路由页面正常显示, 但这时会嵌套一层router-view; 如果把component注释掉, 页面就空了
                render: h => h('router-view')
            },
            children: [
                {
                    path: '/bidder', // 我的点拍-竞买人
                    name: 'bidder',
                    // redirect: '/bidder/b_myMsg', // 重定向我的资料页面
                    // redirect: '/bidder/bidderAuctionManage', // 重定向我要竞拍页面
                    redirect: '/bidder/bidderAuctionManageTar', // 竞买人-拍卖会管理-拍卖标的
                    component: _import('myAuction/bidder/index'),
                    children: [{
                        path: '/bidder/b_myMsg', // 我的资料
                        name: 'b_myMsg',
                        component: _import('myAuction/bidder/myMsg/myMsg')
                    },
                    {
                        path: 'bidderAuctionManage', // 竞买人-拍卖会管理
                        name: 'bidderAuctionManage',
                        component: _import('myAuction/bidder/manage/bidderAuctionManage')
                    },
                    {
                        path: 'bidderAuctionManageTar', // 竞买人-拍卖会管理-拍卖标的
                        name: 'bidderAuctionManageTar',
                        component: _import('myAuction/bidder/manage/bidderAuctionManageTar')
                    },
                    {
                        path: 'bidderBiddingManage', // 竞买人-竞价会管理
                        name: 'bidderBiddingManage',
                        component: _import('myAuction/bidder/manage/bidderBiddingManage')
                    },
                    {
                        path: 'bidderBiddingManageTar', // 竞买人-竞价会管理-竞价标的
                        name: 'bidderBiddingManage',
                        component: _import('myAuction/bidder/manage/bidderBiddingManageTar')
                    },
                    {
                        path: 'sellOffManage', // 竞买人-变卖会管理
                        name: 'sellOffManage',
                        component: _import('myAuction/bidder/manage/sellOffManage')
                    },
                    {
                        path: 'sellOffManageTar', // 竞买人-变卖会管理-竞价标的
                        name: 'sellOffManageTar',
                        component: _import('myAuction/bidder/manage/sellOffManageTar')
                    },
                    {
                        path: 'mySucceeTar', // 我的成交
                        name: 'mySucceeTar',
                        component: _import('myAuction/bidder/mySuccee/succeeTarList')
                    },
                    {
                        path: 'myStatistics', // 统计信息
                        name: 'myStatistics',
                        component: _import('myAuction/bidder/myStatistics/myStatistics')
                    },
                    {
                        path: '/mySucceeTar/succeeTarTar', // 我的成交-查看标的
                        name: 'myAuction',
                        component: _import('myAuction/bidder/mySuccee/surcceeTar')
                    },
                    {
                        path: 'b_changePwd', // 修改密码
                        name: 'b_changePwd',
                        component: _import('myAuction/bidder/myMsg/changePwd')
                    },
                    {
                        path: 'sign', // 修改密码
                        name: 'myAuction',
                        component: _import('myAuction/bidder/sign/sign')
                    }
                    ]
                },
                {
                    path: 'consignor', // 我的点拍 - 委托人
                    name: 'myAuction',
                    redirect: 'consignor/information',
                    component: _import('myAuction/consignor/index'),
                    children: [
                        {
                            path: 'information', // 我的资料
                            name: 'information',
                            component: _import('myAuction/consignor/information/index')
                        },
                        {
                            path: 'conAttract', // 项目招商
                            name: 'conAttract',
                            component: _import('myAuction/consignor/conAttract/index')
                        },
                        {
                            path: 'conAttractAdd', // 添加
                            name: 'conAttract',
                            component: _import('myAuction/consignor/conAttract/function/add')
                        },
                        {
                            path: 'conAttractCheck', // 查看
                            name: 'conAttract',
                            component: _import('myAuction/consignor/conAttract/function/check')
                        },
                        {
                            path: 'conAttractRevise', // 修改
                            name: 'conAttract',
                            component: _import('myAuction/consignor/conAttract/function/revise')
                        },
                        {
                            path: 'conManage', // 项目管理
                            name: 'conManage',
                            component: _import('myAuction/consignor/conManage/index')
                        },
                        {
                            path: 'conManageAdd', // 新增
                            name: 'conManage',
                            component: _import('myAuction/consignor/conManage/function/add')
                        },
                        {
                            path: 'conManageCheck', // 查看
                            name: 'conManage',
                            component: _import('myAuction/consignor/conManage/function/check')
                        },
                        {
                            path: 'conManageRevise', // 修改
                            name: 'conManage',
                            component: _import('myAuction/consignor/conManage/function/revise')
                        },
                        {
                            path: 'conSuper', // 项目监督
                            name: 'conSuper',
                            component: _import('myAuction/consignor/conSuper/index')
                        },
                        {
                            path: 'conSuperH', // 项目监督 - 监督页面
                            name: 'conSuper',
                            component: _import('myAuction/consignor/conSuper/super/index')
                        },
                        {
                            path: 'conAccount', // 项目结算
                            name: 'conAccount',
                            component: _import('myAuction/consignor/conAccount/index')
                        },
                        {
                            path: 'conAccountCheck', // 项目结算 - 查看详情
                            name: 'conAccount',
                            component: _import('myAuction/consignor/conAccount/check')
                        },
                        {
                            path: 'conDelivery', // 项目交割
                            name: 'conDelivery',
                            component: _import('myAuction/consignor/conDelivery/index')
                        },
                        {
                            path: 'conDeliveryAdd', // 项目交割 - 新增
                            name: 'conDelivery',
                            component: _import('myAuction/consignor/conDelivery/add')
                        },
                        {
                            path: 'conDeliveryCheck', // 项目交割 - 查看
                            name: 'conDelivery',
                            component: _import('myAuction/consignor/conDelivery/check')
                        },
                        {
                            path: 'conDeliveryUpdate', // 项目交割 - 修改
                            name: 'conDelivery',
                            component: _import('myAuction/consignor/conDelivery/update')
                        },
                        {
                            path: 'conCount', // 统计汇总
                            name: 'conCount',
                            component: _import('myAuction/consignor/conCount/index')
                        },
                        {
                            path: 'countTarCheck', // 统计汇总 -查看标的详情
                            name: 'conCount',
                            component: _import('myAuction/consignor/conCount/tarCheck')
                        },
                        {
                            path: 'pwUpdate', // 委托人 - 修改密码
                            name: 'pwUpdate',
                            component: _import('myAuction/consignor/pwUpdate/index')
                        }
                    ]
                },
                {
                    path: 'auctionComp', // 我的拍卖，拍卖公司
                    // name: 'myAuction',
                    redirect: 'auctionComp/my_info',
                    component: _import('myAuction/AuctionComp/index'),
                    children: [{
                        path: 'my_info', // 拍卖公司，我的资料
                        name: 'my_info',
                        component: _import('myAuction/AuctionComp/accountInfo/myInfo')
                    },
                    {
                        path: 'info', // 信息总览
                        name: 'info',
                        component: _import('myAuction/AuctionComp/accountInfo/info')
                    },
                    {
                        path: 'interestUser', // 意向用户
                        name: 'interestUser',
                        component: _import('myAuction/AuctionComp/accountInfo/interestUser')
                    },
                    {
                        path: 'underlyingVideo', // 标的视频
                        name: 'underlyingVideo',
                        component: _import('myAuction/AuctionComp/accountInfo/underlyingVideo')
                    },
                    {
                        path: 'change_pwd', // 修改密码
                        name: 'change_pwd',
                        component: _import('myAuction/AuctionComp/accountInfo/changePwd')
                    },

                    /**
                     * 我的点拍 - 拍卖公司
                     * 招商管理
                     */

                    {
                        path: 'project', // 招商管理
                        name: 'project',
                        component: _import('myAuction/AuctionComp/investment/list')
                    },
                    {
                        path: 'project1', // 招商管理
                        name: 'project1',
                        component: _import('myAuction/AuctionComp/sign/sign')
                    },
                    {
                        path: 'add', // 新增招商
                        name: 'project',
                        component: _import('myAuction/AuctionComp/investment/add')
                    },
                    {
                        path: 'add_project', // 新增招商
                        name: 'add_project',
                        component: _import('myAuction/AuctionComp/investment/addList')
                    },
                    {
                        path: 'check', // 查看项目
                        name: 'project',
                        component: _import('myAuction/AuctionComp/investment/check')
                    },
                    {
                        path: 'update', // 编辑项目
                        name: 'project',
                        component: _import('myAuction/AuctionComp/investment/update')
                    },



                    /**
                     * 我的点拍 - 拍卖公司
                     * 拍卖管理
                     */

                    /**
                     * 拍卖管理 - 公告管理
                     */
                    {
                        path: 'noticeManage', // 公告管理
                        name: 'noticeManage',
                        component: _import('myAuction/AuctionComp/auctionManage/aucNotice/manageNotice')
                    },
                    {
                        path: 'noticeCheck', // 查看公告
                        name: 'noticeManage',
                        component: _import('myAuction/AuctionComp/auctionManage/aucNotice/noticeCheck')
                    },
                    {
                        path: 'noticeUpdate', // 修改公告
                        name: 'noticeManage',
                        component: _import('myAuction/AuctionComp/auctionManage/aucNotice/noticeUpdate')
                    },
                    {
                        path: 'noticeAdd', // 新增公告
                        name: 'noticeManage',
                        component: _import('myAuction/AuctionComp/auctionManage/aucNotice/noticeAdd')
                    },
                        /**
                     * 变卖管理 - 公告管理
                     */

                    {
                        path: 'noticeSellManage', // 公告管理
                        name: 'noticeSellManage',
                        component: _import('myAuction/AuctionComp/auctionManage/noticeSell/manageNotice')
                    },
                    {
                        path: 'noticeSellCheck', // 查看公告
                        name: 'noticeSellManage',
                        component: _import('myAuction/AuctionComp/auctionManage/noticeSell/noticeCheck')
                    },
                    {
                        path: 'noticeSellUpdate', // 修改公告
                        name: 'noticeSellManage',
                        component: _import('myAuction/AuctionComp/auctionManage/noticeSell/noticeUpdate')
                    },
                    {
                        path: 'noticeSellAdd', // 新增公告
                        name: 'noticeSellManage',
                        component: _import('myAuction/AuctionComp/auctionManage/noticeSell/noticeAdd')
                    },
                    /**
                     * 拍卖管理 - 拍卖管理
                     */

                    {
                        path: 'auctionManage', // 拍卖会管理
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/auctionManage/auctionMeet/auctionMeet/auction')
                    },
                    {
                        path: 'auctionCheck', // 查看
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/auctionManage/auctionMeet/auctionMeet/editorAuction')
                    },
                    {
                        path: 'auctionRevise', // 修改
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/auctionManage/auctionMeet/auctionMeet/reviseAuction')
                    },
                    {
                        path: 'auctionAdd', // 新增
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/auctionManage/auctionMeet/auctionMeet/addAuction')
                    },

                    /**
                     * 变卖管理 - 变卖管理
                     */

                    {
                        path: 'sellOffManage', // 变卖会管理
                        name: 'sellOffManage',
                        component: _import('myAuction/AuctionComp/sellOffManage/manage/manage/index')
                    },
                    {
                        path: 'sellOffCheck', // 查看
                        name: 'sellOffManage',
                        component: _import('myAuction/AuctionComp/sellOffManage/manage/manage/check')
                    },
                    {
                        path: 'sellOffUpdate', // 修改
                        name: 'sellOffManage',
                        component: _import('myAuction/AuctionComp/sellOffManage/manage/manage/update')
                    },
                    {
                        path: 'sellOffAdd', // 新增
                        name: 'sellOffManage',
                        component: _import('myAuction/AuctionComp/sellOffManage/manage/manage/add')
                    },

                    /**
                     * 变卖管理 - 变卖会管理 - 标的管理
                     */

                    {
                        path: 'sAdd', // 新增
                        name: 'sellOffManage',
                        component: _import('myAuction/AuctionComp/sellOffManage/manage/tar/add')
                    },
                    {
                        path: 'sCheck', // 查看
                        name: 'sellOffManage',
                        component: _import('myAuction/AuctionComp/sellOffManage/manage/tar/check')
                    },
                    {
                        path: 'sCheckU', // 查看
                        name: 'sellOffManage',
                        component: _import('myAuction/AuctionComp/sellOffManage/manage/tar/checkU')
                    },
                    {
                        path: 'sUpdate', // 修改
                        name: 'sellOffManage',
                        component: _import('myAuction/AuctionComp/sellOffManage/manage/tar/update')
                    },

                    /**
                     * 变卖管理 - 变卖会管理 - 权限管理
                     */

                    {
                        path: 'spManage', // 管理页面
                        name: 'sellOffManage',
                        component: _import('myAuction/AuctionComp/sellOffManage/manage/Power/index')
                    },
                    {
                        path: 'spCheck', // 查看
                        name: 'sellOffManage',
                        component: _import('myAuction/AuctionComp/sellOffManage/manage/Power/check')
                    },
                    {
                        path: 'spUpdate', // 修改
                        name: 'sellOffManage',
                        component: _import('myAuction/AuctionComp/sellOffManage/manage/Power/update')
                    },
                    {
                        path: 'spYes', // 确认
                        name: 'sellOffManage',
                        component: _import('myAuction/AuctionComp/sellOffManage/manage/Power/yes')
                    },

                    /**
                     * 变卖管理 - 变卖会管理 - 成交公示管理
                     */

                    {
                        path: 'ssManage', // 管理页面
                        name: 'sellOffManage',
                        component: _import('myAuction/AuctionComp/sellOffManage/success/index')
                    },
                    {
                        path: 'ssCheck', // 查看
                        name: 'sellOffManage',
                        component: _import('myAuction/AuctionComp/sellOffManage/success/check')
                    },
                    {
                        path: 'ssUpdate', // 修改
                        name: 'sellOffManage',
                        component: _import('myAuction/AuctionComp/sellOffManage/success/update')
                    },
                    {
                        path: 'ssAdd', // 新增
                        name: 'sellOffManage',
                        component: _import('myAuction/AuctionComp/sellOffManage/success/add')
                    },
                        /**
                     * 变卖管理 - 变卖会管理 - 成交公示管理
                     */

                    {
                        path: 'snManage', // 管理页面
                        name: 'sellOffManage',
                        component: _import('myAuction/AuctionComp/sellOffManage/notice/index')
                    },
                    {
                        path: 'snCheck', // 查看
                        name: 'sellOffManage',
                        component: _import('myAuction/AuctionComp/sellOffManage/notice/check')
                    },
                    {
                        path: 'snUpdate', // 修改
                        name: 'sellOffManage',
                        component: _import('myAuction/AuctionComp/sellOffManage/notice/update')
                    },
                    {
                        path: 'snAdd', // 新增
                        name: 'sellOffManage',
                        component: _import('myAuction/AuctionComp/sellOffManage/notice/add')
                    },
                    /**
                     * 竞价管理 - 竞价会管理
                     *
                     * 标的管理
                     */
                    {
                        path: 'BidManagement', // 竞价会管理
                        name: 'BidManagement',
                        component: _import('myAuction/AuctionComp/biddingManage/bidMeet/bidMeet/bidding')
                    },
                    {
                        path: 'sellTarAdd', // 标的新增
                        name: 'auctionSellManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidMeet/sellTar/addTar')
                    },
                    {
                        path: 'sellCheck_TarCheck', // 竞价会查看 - 标的查看
                        name: 'auctionSellManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidMeet/sellTar/checkTarAuc')
                    },
                    {
                        path: 'sellRevise_TarCheck', // 竞价会修改 - 标的查看
                        name: 'auctionSellManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidMeet/sellTar/checkTar')
                    },
                    {
                        path: 'sellTarRevise', // 标的修改
                        name: 'auctionSellManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidMeet/sellTar/editorTar')
                    },

                    /**
                     * 拍卖管理 - 拍卖会管理 - 标的管理
                     */

                    {
                        path: 'aucTarAdd', // 标的新增
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/auctionManage/auctionMeet/auctionTar/addTar')
                    },
                    {
                        path: 'aucCheck_TarCheck', // 拍卖会查看 - 标的查看
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/auctionManage/auctionMeet/auctionTar/checkTarAuc')
                    },
                    {
                        path: 'aucRevise_TarCheck', // 拍卖会修改 - 标的修改
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/auctionManage/auctionMeet/auctionTar/checkTar')
                    },
                    {
                        path: 'aucTarRevise', // 标的修改
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/auctionManage/auctionMeet/auctionTar/editorTar')
                    },

                    /**
                     * 拍卖管理 - 拍卖会管理 - 附件
                     */

                    {
                        path: 'registerTable', // 拍卖会查看 - 登记表打印
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/auctionManage/auctionMeet/auctionAcc/registerTable')
                    },
                    {
                        path: 'takeDownTable', // 拍卖会查看 - 笔录打印
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/auctionManage/auctionMeet/auctionAcc/takeDownTable')
                    },
                    {
                        path: 'confirmTable', // 拍卖管理拍 =>成交确认书打印
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/auctionManage/auctionMeet/auctionAcc/confirmTable')
                    },
                    {
                        path: 'aucRegisterTableOne', // 拍卖管理拍 =>登记表打印
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/auctionManage/auctionMeet/auctionAcc/registerTableOne')
                    },

                    /**
                     * 拍卖管理 - 拍卖会管理 - 竞买权限管理
                     */

                    {
                        path: 'aucPowerManage', // 拍卖管理or竞价管理 => 权限管理
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/auctionManage/auctionMeet/aucPower/powerManage')
                    },
                    {
                        path: 'aucPowerCheck', // 拍卖管理or竞价管理 => 权限查看
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/auctionManage/auctionMeet/aucPower/powerCheck')
                    },
                    {
                        path: 'aucPowerRevise', // 拍卖管理or竞价管理 => 权限修改
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/auctionManage/auctionMeet/aucPower/powerRevise')
                    },
                    {
                        path: 'aucPowerAffirm', // 拍卖管理or竞价管理 => 权限确认
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/auctionManage/auctionMeet/aucPower/powerAffirm')
                    },

                    /**
                     * 拍卖管理 - 拍卖会管理 - 标的监拍管理
                     */
                    {
                        path: 'aucSuperManage', // 监拍人管理
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/supervisorManage/right/right')
                    },
                    {
                        path: '/supervisor_manage/info', // 监拍人信息
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/supervisorManage/info')
                    },
                    {
                        path: '/supervisor_manage/add', // 新增监拍人
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/supervisorManage/add')
                    },
                    {
                        path: '/supervisor_manage/add', // 新增监拍人
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/supervisorManage/add')
                    },

                    {
                        path: '/supervisor_manage/right/rightAdd', // 监拍人增加标的
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/supervisorManage/right/rightAdd')
                    },
                    {
                        path: '/supervisor_manage/right/rightTarget', // 监拍人查看标的
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/supervisorManage/right/rightTarget')
                    },
                    {
                        path: '/supervisor_manage/right/rightSet', // 监拍人修改标的
                        name: 'auctionManage',
                        component: _import('myAuction/AuctionComp/supervisorManage/right/rightSet')
                    },

                    /**
                     * 拍卖管理 - 成交公示管理
                     */

                    {
                        path: 'aucSuccessManage', // 成交公示列表
                        name: 'aucSuccessManage',
                        component: _import('myAuction/AuctionComp/auctionManage/aucSuccess/doneManage')
                    },
                    {
                        path: 'aucSuccessCheck', // 成交公示查看
                        name: 'aucSuccessManage',
                        component: _import('myAuction/AuctionComp/auctionManage/aucSuccess/checkDone')
                    },
                    {
                        path: 'aucSuccessAdd', // 成交公示增加
                        name: 'aucSuccessManage',
                        component: _import('myAuction/AuctionComp/auctionManage/aucSuccess/addDone')
                    },
                    {
                        path: 'aucSuccessRevise', // 成交公示查看
                        name: 'aucSuccessManage',
                        component: _import('myAuction/AuctionComp/auctionManage/aucSuccess/reviseDone')
                    },

                    /**
                     * 竞价管理 - 公告管理0
                     */

                    {
                        path: 'bidNotice', // 公告管理
                        name: 'bidNotice',
                        component: _import('myAuction/AuctionComp/biddingManage/bidNotice/notice')
                    },
                    {
                        path: 'bidNoticeCheck', // 查看公告
                        name: 'bidNotice',
                        component: _import('myAuction/AuctionComp/biddingManage/bidNotice/noticeCheck')
                    },
                    {
                        path: 'bidNoticeRevise', // 修改公告
                        name: 'bidNotice',
                        component: _import('myAuction/AuctionComp/biddingManage/bidNotice/noticeUpdate')
                    },
                    {
                        path: 'bidNoticeAdd', // 新增公告
                        name: 'bidNotice',
                        component: _import('myAuction/AuctionComp/biddingManage/bidNotice/noticeAdd')
                    },

                    /**
                     * 竞价管理 - 竞价会管理
                     */

                    {
                        path: 'bidManage', // 竞价会管理
                        name: 'bidManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidMeet/bidMeet/bidding')
                    },
                    {
                        path: 'bidCheck', // 查看竞价会
                        name: 'bidManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidMeet/bidMeet/bidCheck')
                    },
                    {
                        path: 'bidUpdate', // 修改竞价会
                        name: 'bidManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidMeet/bidMeet/bidUpdate')
                    },
                    {
                        path: 'bidAdd', // 新增竞价会
                        name: 'bidManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidMeet/bidMeet/bidAdd')
                    },

                    /**
                     * 竞价管理 - 竞价会管理
                     *
                     * 标的管理
                     */
                    {
                        path: 'bidTarAdd', // 标的新增
                        name: 'bidManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidMeet/bidTar/addTar')
                    },
                    {
                        path: 'bidCheck_TarCheck', // 竞价会查看 - 标的查看
                        name: 'bidManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidMeet/bidTar/checkTarAuc')
                    },
                    {
                        path: 'bidRevise', // 竞价会修改 - 标的查看
                        name: 'bidManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidMeet/bidTar/checkTar')
                    },
                    {
                        path: 'bidTarRevise', // 标的修改
                        name: 'bidManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidMeet/bidTar/editorTar')
                    },
                    /**
                     * 竞价管理 - 竞价会管理
                     *
                     * 附件
                     */
                    {
                        path: 'bidRegisterTable', // 竞价会管理拍 =>登记表打印列表
                        component: _import('myAuction/AuctionComp/biddingManage/bidMeet/bidAcc/registerTable')
                    },
                    {
                        path: 'bidTakeDownTable', // 竞价会管理拍 =>笔录打印
                        component: _import('myAuction/AuctionComp/biddingManage/bidMeet/bidAcc/takeDownTable')
                    },
                    {
                        path: 'bidConfirmTable', // 竞价会管理拍 =>成交确认书打印
                        component: _import('myAuction/AuctionComp/biddingManage/bidMeet/bidAcc/confirmTable')
                    },
                    {
                        path: '/bidding_price/auction/registerTableOne', // 竞价会管理拍 =>登记表打印
                        component: _import('myAuction/AuctionComp/biddingManage/bidMeet/bidAcc/registerTableOne')
                    },

                    /**
                     * 竞价管理 - 竞价会管理
                     *
                     * 竞买权限管理
                     */

                    {
                        path: 'bidPowerManage', // 竞价管理 => 权限管理
                        name: 'bidManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidMeet/bidPower/powerManage')
                    },
                    {
                        path: 'bidPowerCheck', // 竞价管理 => 权限查看
                        name: 'bidManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidMeet/bidPower/powerCheck')
                    },
                    {
                        path: 'bidPowerRevise', // 竞价管理 => 权限修改
                        name: 'bidManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidMeet/bidPower/powerRevise')
                    },
                    {
                        path: 'bidPowerAffirm', // 竞价管理 => 权限确认
                        name: 'bidManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidMeet/bidPower/powerAffirm')
                    },

                    /**
                     * 竞价管理 - 成交公示管理
                     *
                     */
                    {
                        path: 'bidSuccessManage', // 成交公示列表
                        name: 'bidSuccessManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidSuccess/doneManage')
                    },
                    {
                        path: 'bidSuccessCheck', // 成交公示查看
                        name: 'bidSuccessManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidSuccess/checkDone')
                    },
                    {
                        path: 'bidSuccessAdd', // 成交公示增加
                        name: 'bidSuccessManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidSuccess/addDone')
                    },
                    {
                        path: 'bidSuccessRevise', // 成交公示修改
                        name: 'bidSuccessManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidSuccess/reviseDone')
                    },

                    /**
                     * 拍卖管理 - 事故车 - 公告管理
                     */
                    {
                        path: 'carNoticeManage', // 事故车公告管理
                        name: 'carNoticeManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/aucNotice/manageNotice')
                    },
                    {
                        path: 'carNoticeCheck', // 事故车查看公告
                        name: 'carNoticeManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/aucNotice/noticeCheck')
                    },
                    {
                        path: 'carNoticeUpdate', // 事故车修改公告
                        name: 'carNoticeManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/aucNotice/noticeUpdate')
                    },
                    {
                        path: 'carNoticeAdd', // 事故车新增公告
                        name: 'carNoticeManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/aucNotice/noticeAdd')
                    },
                    /**
                     * 拍卖管理 - 拍卖管理 - 事故车
                     */

                    {
                        path: 'carAuctionManage', // 拍卖会管理
                        name: 'carAuctionManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/auctionMeet/auctionMeet/auction')
                    },
                    {
                        path: 'carAuctionCheck', // 查看
                        name: 'carAuctionManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/auctionMeet/auctionMeet/editorAuction')
                    },
                    {
                        path: 'carAuctionRevise', // 修改
                        name: 'carAuctionManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/auctionMeet/auctionMeet/reviseAuction')
                    },
                    {
                        path: 'carAuctionAdd', // 新增
                        name: 'carAuctionManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/auctionMeet/auctionMeet/addAuction')
                    },

                    /**
                     * 事故车拍卖管理 - 拍卖会管理 - 竞买权限管理 - 事故车
                     */

                    {
                        path: 'carAucPowerManage', // 拍卖管理or竞价管理 => 权限管理- 事故车
                        name: 'carauctionManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/auctionMeet/aucPower/powerManage')
                    },
                    {
                        path: 'caraucPowerCheck', // 拍卖管理or竞价管理 => 权限查看- 事故车
                        name: 'carauctionManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/auctionMeet/aucPower/powerCheck')
                    },
                    {
                        path: 'caraucPowerRevise', // 拍卖管理or竞价管理 => 权限修改- 事故车
                        name: 'carauctionManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/auctionMeet/aucPower/powerRevise')
                    },
                    {
                        path: 'caraucPowerAffirm', // 拍卖管理or竞价管理 => 权限确认- 事故车
                        name: 'carauctionManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/auctionMeet/aucPower/powerAffirm')
                    },
                    /**
                     * 拍卖管理 - 拍卖会管理 - 标的管理- 事故车
                     */

                    {
                        path: 'caraucTarAdd', // 标的新增
                        name: 'carauctionManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/auctionMeet/auctionTar/addTar')
                    },
                    {
                        path: 'caraucCheck_TarCheck', // 拍卖会查看 - 标的查看
                        name: 'carauctionManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/auctionMeet/auctionTar/checkTarAuc')
                    },
                    {
                        path: 'caraucRevise_TarCheck', // 拍卖会修改 - 标的修改
                        name: 'carauctionManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/auctionMeet/auctionTar/checkTar')
                    },
                    {
                        path: 'caraucTarRevise', // 标的修改
                        name: 'carauctionManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/auctionMeet/auctionTar/editorTar')
                    },
                    /**
                     * 拍卖管理 - 成交公示管理 - 事故车
                     */

                    {
                        path: 'caraucSuccessManage', // 成交公示列表
                        name: 'caraucSuccessManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/aucSuccess/doneManage')
                    },
                    {
                        path: 'caraucSuccessCheck', // 成交公示查看
                        name: 'caraucSuccessManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/aucSuccess/checkDone')
                    },
                    {
                        path: 'caraucSuccessAdd', // 成交公示增加
                        name: 'caraucSuccessManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/aucSuccess/addDone')
                    },
                    {
                        path: 'caraucSuccessRevise', // 成交公示查看
                        name: 'caraucSuccessManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/aucSuccess/reviseDone')
                    },
                    /**
                     * 拍卖管理 - 拍卖会管理 - 附件
                     */

                    {
                        path: 'carregisterTable', // 拍卖会查看 - 登记表打印
                        name: 'carauctionManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/auctionMeet/auctionAcc/registerTable')
                    },
                    {
                        path: 'cartakeDownTable', // 拍卖会查看 - 笔录打印
                        name: 'carauctionManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/auctionMeet/auctionAcc/takeDownTable')
                    },
                    {
                        path: 'carconfirmTable', // 拍卖管理拍 =>成交确认书打印
                        name: 'carauctionManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/auctionMeet/auctionAcc/confirmTable')
                    },
                    {
                        path: 'caraucRegisterTableOne', // 拍卖管理拍 =>登记表打印
                        name: 'carauctionManage',
                        component: _import('myAuction/AuctionComp/AccidentVehicle/auctionMeet/auctionAcc/registerTableOne')
                    },

                    /**
                     * 委托管理 - 项目委托
                     *
                     */
                    {
                        path: 'tarDelivery', // 项目委托
                        name: 'tarDelivery',
                        component: _import('myAuction/AuctionComp/entrustManage/tarDelivery/index')
                    },
                    {
                        path: 'tarDeliveryCheck', // 项目委托 -查看详情
                        name: 'tarDelivery',
                        component: _import('myAuction/AuctionComp/entrustManage/tarDelivery/check')
                    },
                    {
                        path: 'tarEntrust', // 项目结算
                        name: 'tarEntrust',
                        component: _import('myAuction/AuctionComp/entrustManage/tarEntrust/index')
                    },
                    {
                        path: 'tarEntrustAdd', // 项目结算 - 新增
                        name: 'tarEntrust',
                        component: _import('myAuction/AuctionComp/entrustManage/tarEntrust/add')
                    },
                    {
                        path: 'tarEntrustCheck', // 项目结算 - 查看
                        name: 'tarEntrust',
                        component: _import('myAuction/AuctionComp/entrustManage/tarEntrust/check')
                    },
                    {
                        path: 'tarEntrustUpdate', // 项目结算 - 修改
                        name: 'tarEntrust',
                        component: _import('myAuction/AuctionComp/entrustManage/tarEntrust/update')
                    },
                    {
                        path: 'bidSuccessAdd', // 成交公示增加
                        name: 'bidSuccessManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidSuccess/addDone')
                    },
                    {
                        path: 'bidSuccessRevise', // 成交公示修改
                        name: 'bidSuccessManage',
                        component: _import('myAuction/AuctionComp/biddingManage/bidSuccess/reviseDone')
                    },

                    {
                        path: '/graph/knowledge', // 知识图谱 - 知识库
                        component: _import('myAuction/AuctionComp/graph/knowledge')
                    },
                    {
                        path: '/graph/company', // 知识图谱 - 企业库
                        component: _import('myAuction/AuctionComp/graph/company')
                    },
                    {
                        path: '/graph/graphList', // 项目匹配-知识图谱展示
                        component: _import('myAuction/AuctionComp/graph/matching/graphList')
                    },
                    {
                        path: '/graph/matchingList', // 项目匹配-知识图谱展示-查看匹配公司
                        component: _import('myAuction/AuctionComp/graph/matching/matchingList')
                    },
                    {
                        path: '/graph/checkScore', // 项目匹配-知识图谱展示-查看匹配公司
                        component: _import('myAuction/AuctionComp/graph/matching/checkScore')
                    },
                    // checkScore
                    {
                        path: '/graph/checkGraph', // 查看图谱
                        component: _import('myAuction/AuctionComp/graph/checkGraph')
                    },
                    {
                        path: '/graph/project', // 知识图谱 - 项目库
                        component: _import('myAuction/AuctionComp/graph/project')
                    },
                    {
                        path: '/graph/projectLibrary', // 知识图谱 - 项目库
                        component: _import('myAuction/AuctionComp/graph/projectLibrary')
                    },
                    {
                        path: '/graph/model', // 知识图谱 - 模型库
                        component: _import('myAuction/AuctionComp/graph/model')
                    },
                    {
                        path: '/graph/model/checkModel', // 知识图谱 - 模型库-查看知识图谱
                        component: _import('myAuction/AuctionComp/graph/modelMatching/checkModel')
                    },
                    {
                        path: '/graph/resModel', // 知识图谱 - 模型修改
                        component: _import('myAuction/AuctionComp/graph/resModel')
                    },

                    /**
                     * 统计管理
                     *
                     */
                    {
                        path: 'buy', // 竞买统计
                        name: 'buy',
                        component: _import('myAuction/AuctionComp/buyManage/list')
                    },
                    {
                        path: 'pay', // 拍卖公司统计是否缴费
                        name: 'pay',
                        component: _import('myAuction/AuctionComp/buyManage/pay')
                    },
                    {
                        path: 'buyTarCheck', // 竞买统计查看标的详情
                        name: 'buy',
                        component: _import('myAuction/AuctionComp/buyManage/buyTarCheck')
                    },
                    {
                        path: 'count', // 统计汇总 countTarCheck
                        name: 'count',
                        component: _import('myAuction/AuctionComp/buyManage/count')
                    },
                    {
                        path: 'aucCountTarCheck', // 统计汇总查看标的详情
                        name: 'count',
                        component: _import('myAuction/AuctionComp/buyManage/countTarCheck')
                    },
                    /**
                     * 我的点拍 - 拍卖师管理
                     *
                     */

                    {
                        path: 'auctioneerManage', // 拍卖师信息
                        name: 'auctioneerManage',
                        component: _import('myAuction/AuctionComp/auctioneerManage/info')
                    },
                    {
                        path: 'auctioneerAdd', // 新增拍卖师
                        name: 'auctioneerAdd',
                        component: _import('myAuction/AuctionComp/auctioneerManage/add')
                    },

                    /**
                     * 我的点拍 - 监拍人管理
                     *
                     */

                    {
                        path: 'superManage', // 监拍人信息
                        name: 'superManage',
                        component: _import('myAuction/AuctionComp/supervisorManage/info')
                    },
                    {
                        path: 'agreementList', // 协议列表
                        name: 'agreementList',
                        component: _import('myAuction/AuctionComp/supervisorManage/agreementList')
                    },
                    {
                        path: 'superAdd', // 新增监拍人
                        name: 'superAdd',
                        component: _import('myAuction/AuctionComp/supervisorManage/add')
                    },
                    {
                        path: 'superRight', // 监拍人权限
                        component: _import('myAuction/AuctionComp/supervisorManage/right/right')
                    },
                    {
                        path: '/supervisor_manage/right/rightAdd', // 监拍人增加标的
                        component: _import('myAuction/AuctionComp/supervisorManage/right/rightAdd')
                    },
                    {
                        path: '/supervisor_manage/right/rightTarget', // 监拍人查看标的
                        component: _import('myAuction/AuctionComp/supervisorManage/right/rightTarget')
                    },
                    {
                        path: '/supervisor_manage/right/rightSet', // 监拍人修改标的
                        component: _import('myAuction/AuctionComp/supervisorManage/right/rightSet')
                    },
                    {
                        path: '/count_manage/peron', // 意向竞买人信息
                        component: _import('myAuction/AuctionComp/accountInfo/interestUser')
                    }
                    ]
                },

                {
                    path: '/auctioneer', // 我的拍卖，拍卖师
                    name: 'auctioneer',
                    redirect: '/auctioneer/charge',
                    component: _import('myAuction/auctioneer/index'),
                    children: [{
                        path: '/auctioneer/myMsg', // 我的资料
                        name: 'auctioneer_myMsg',
                        component: _import('myAuction/auctioneer/myMsg/myMsg')
                    },
                    {
                        path: '/auctioneer/myMsg1', // 我的资料
                        name: 'auctioneer_myMsg1',
                        component: _import('myAuction/auctioneer/myMsg/myMsg1')
                    },
                    {
                        path: '/auctioneer/charge', // 我的拍卖主持
                        name: 'auctioneer_charge',
                        component: _import('myAuction/auctioneer/manage/charge')
                    },
                    {
                        path: '/auctioneer/chargeA', // 我的竞价主持
                        name: 'auctioneer_chargeA',
                        component: _import('myAuction/auctioneer/manage/chargeA')
                    },
                    {
                        path: '/auctioneer/sellOffManageAuc', // 我的变卖主持
                        component: _import('myAuction/auctioneer/manage/sellOffManageAuc')
                    },
                    {
                        path: '/auctioneer/charge', // 我的-事故车-主持
                        name: 'auctioneer_charge',
                        component: _import('myAuction/auctioneer/AccidentVehicle/charge')
                    },
                    {
                        path: '/auctioneer/charge', // 我的意向报价 - 事故车辆
                        name: 'auctioneer_charge',
                        component: _import('myAuction/auctioneer/AccidentVehicle/charge')
                    },
                    {
                        path: '/AccidentVehicle/charge', // 我的拍卖事故车主持 - 事故车辆
                        name: 'auctioneer_AccidentVehicle_charge',
                        component: _import('myAuction/auctioneer/AccidentVehicle/charge')
                    },
                    {
                        path: '/auctioneer/collect', // 拍卖师-统计汇总
                        name: 'collect',
                        component: _import('myAuction/auctioneer/manage/collect')
                    },
                    {
                        path: '/auctioneer/changePwd', // 拍卖师-修改密码
                        name: 'changePwd',
                        component: _import('myAuction/auctioneer/manage/changePwd')
                    },
                    {
                        path: '/auctioneer/charge/addEditor', // 拍卖师 = 竞拍管理拍 =>查看编辑
                        component: _import('myAuction/auctioneer/manage/addEditor')
                    },
                    {
                        path: '/auctioneer/charge/sellOff', // 拍卖师 = 变卖管理拍 =>查看编辑
                        component: _import('myAuction/auctioneer/manage/sellOff/index')
                    },
                    {
                        path: '/auctioneer/charge/addEditorA', // 拍卖师 = 竞价管理拍 =>查看编辑
                        component: _import('myAuction/auctioneer/manage/addEditorA')
                    },
                    {
                        path: '/auctioneer/charge/caraddEditor', // 拍卖师 = 事故车-管理 =>查看编辑
                        component: _import('myAuction/auctioneer/AccidentVehicle/addEditor')
                    },
                    {
                        path: '/auctioneer/auction/registerTable', // 登记表打印列表 ------auctioneer：拍卖师账号
                        component: _import('myAuction/auctioneer/manage/registerTable')
                    },
                    {
                        path: '/auctioneer/auction/registerTableOne', // 登记表打印
                        component: _import('myAuction/auctioneer/manage/registerTableOne')
                    },
                    {
                        path: '/auctioneer/auction/confirmTable', // 成交确认书打印
                        component: _import('myAuction/auctioneer/manage/confirmTable')
                    },
                    {
                        path: '/auctioneer/auction/takeDownTable', // 笔录打印
                        component: _import('myAuction/auctioneer/manage/takeDownTable')
                    }
                    ]
                }
            ]
        },
        {
            path: '/supervisor', // 我的拍卖，监拍人
            name: 'supervisor',
            redirect: '/supervisor/charge',
            component: _import('myAuction/supervisor/index'),
            children: [
                {
                    path: '/supervisor/charge', // 标的监拍
                    name: 'supervisor_charge',
                    component: _import('myAuction/supervisor/manage/charge')
                }
            ]
        },
        {
            path: '/auctioneer/auction', // 拍卖师-竞拍页面
            name: '_auctioneer',
            component: _import('myAuction/auctioneer/auction')
        },
        {
            path: '/auctioneer/sellOff', // 拍卖师-竞拍页面
            name: '_auctioneer',
            component: _import('myAuction/auctioneer/sellOff')
        },
        {
            path: '/supervisor/auction', // 监拍详情页
            name: 'supervisor_auction',
            component: _import('myAuction/supervisor/auction/auction')
        },
        {
            path: '/supervisor/bidding', // 监拍详情页
            name: 'supervisor_bidding',
            component: _import('myAuction/supervisor/auction/bidding')
        },
        {
            path: '/auctioneer/auctionA', // 拍卖师-竞价页面
            name: '_auctioneer',
            component: _import('myAuction/auctioneer/auctionA')
        },
        {
            path: '/bidder/auction', // 竞买人-竞拍页面
            name: 'bidderAuction',
            component: _import('myAuction/bidder/auction/auction')
        },
        {
            path: '/bidder/auctionDBD', // 竞买人-竞拍页面-多个标的专项页面
            name: 'bidderAuction',
            component: _import('myAuction/bidder/auction/auctionDBD')
        },
        {
            path: '/bidder/bidding', // 竞买人-竞价页面
            name: 'bidderBidding',
            component: _import('myAuction/bidder/auction/bidding')
        },
        {
            path: '/bidder/sellOff', // 竞买人-变卖页面
            name: 'sellOff',
            component: _import('myAuction/bidder/auction/sellOff')
        },
        {
            path: '/importProject', // 竞买者拍竞买页面
            name: 'importProject',
            component: _import('imProject/imProject')
        },
        {
            path: '/AuctionRegistration', // 资产拍卖登记
            name: 'AuctionRegistration',
            component: () => import('@/view/AuctionRegistration/AuctionRegistration')
        },
        {
            path: '/NeedToRegister', // 资产拍卖登记
            name: 'NeedToRegister',
            component: () => import('@/view/NeedToRegister/NeedToRegister')
        }
        ]
    }
];



// WEBPACK FOOTER //
// ./src/router/dp.js